import * as React from 'react';

import * as warningImg from '../../assets/image/warning.png';

import './style.scss';

interface Props {
  message: string;
}

const ErrorMessage = (props: Props) => {
  return(
    <section className='error-container d-flex justify-around align-center'>
      <img
        className='error-image'
        alt='Error'
        src={warningImg} />
      <div className='error-content d-flex justify-around align-center'>
        <span className='bold'>{'Warning: '}</span>
        <p>{props.message}</p>
      </div>
    </section>
  );
};

export default ErrorMessage;
